export default "__VITE_ASSET__D1vyCc9A__"